import { Button, ButtonGroup, Link, Card, Grid, Paper, Table, TableContainer, TableRow, TableCell, Typography, TextField, CardContent } from '@mui/material';
import React, { useState } from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';
import Loading from '../components/Loading';
import { Box, Stack } from '@mui/system';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewArrayIcon from '@mui/icons-material/ViewArray';
import EditIcon from '@mui/icons-material/Edit';
import { useCreateDesignCategoryMutation, useListDesignCategoriesQuery } from '../features/model/designcategorySlice';

const DesignCategoryAddNewCard = ({onAddCategory = null}) => {
  const addNewCategory = (name) => {
      if(onAddCategory) {
          onAddCategory(name);
      }
  }

  return (
      <Paper elevation={1}><Card key="add_new" sx={{width: 256, minHeight: 140, paddingTop: 2}}>
          <center><Typography variant="subtitle1">Add new</Typography></center>
          <center><TextField
              sx={{marginTop: 2}}
              placeholder='Type and press enter...'
              onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                      addNewCategory(e.target.value);
                  }
              }}
          /></center>
      </Card></Paper>);
}

const DesignCategoriesBrowser = () => {
    let params = useParams();
    const navigate = useNavigate();

    const {data: categories, error, isLoading } = useListDesignCategoriesQuery()
    const [createCategory] = useCreateDesignCategoryMutation();
    
    if (isLoading) {
      return <Loading />;
    }
    if (error) {
      return <div>Error: {error}</div>
    }

    const makeLinkToCategory = (category) => {
      return `/designs/${category.id}`
    }

    const addCategory = (name) => {
      let new_category = {
        name: name
      };
      createCategory(new_category);
    }

    return <Grid container spacing={2} sx={{marginTop: 2, marginBottom: 4}}>
        {
            categories.objects.map((category, i) => {
            return <Grid item key={category.id} component={RouterLink} to={makeLinkToCategory(category)}>
                <Paper elevation={1}>
                  <Card sx={{width: 256, minHeight: 140, paddingTop: 4}}>
                    <CardContent>
                      <Typography variant="subtitle1" textAlign="center">{category.name}</Typography>
                    </CardContent>
                  </Card>
                </Paper>
              </Grid>;
            })
        }
        <Grid item key="new"><DesignCategoryAddNewCard onAddCategory={addCategory} /></Grid>
        </Grid>
}

export default DesignCategoriesBrowser;
